<script setup>
  import { ref } from 'vue';

  defineOptions({
    inheritAttrs: false,
  });

  const show = ref(false);
</script>
<template>
  <div class="action-item" @click="show = true" tabindex="0" @keydown.enter="show = true" v-bind="$attrs">
    <div class="icon-wrapper">
      <SfIconGeoAlt class="icon" />
    </div>
  </div>
  <SfDrawerWarehouse v-model:open="show" />
</template>
<style lang="scss" scoped>
  .action-item {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    gap: 1rem;
    font-size: 1.5rem;
    height: 100%;
    color: var(--color-main-black);
    text-decoration: none;
    cursor: pointer;
    white-space: nowrap;
    transition-property: color;
    transition-duration: var(--transition-primary-duration);
    transition-timing-function: var(--transition-primary-timing-function);

    &:hover {
      color: var(--primary-color);
    }

    .icon-wrapper {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 1.5rem;

      .mini-cart-count {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 0.75rem;
        line-height: 1;
        font-weight: var(--font-weight-500);
        min-width: 1.25rem;
        text-align: center;
        vertical-align: middle;
        padding: 0.25rem 0.375rem;
        color: var(--color-black);
        transform: translate(0.625rem, -50%);
        background-color: var(--primary-color);
        border-radius: 1.5rem;
      }
    }

    .cart-value-wrapper {
      display: flex;
      flex-direction: column;
      gap: 0;
      line-height: 1;
    }

    .cart-value-gross {
      font-size: 0.75rem;
    }

    .cart-value {
      font-size: 1rem;
      transition-property: font-size, opacity;
      transition-duration: var(--transition-primary-duration);
      transition-timing-function: var(--transition-primary-timing-function);
    }
  }

  @media(max-width: 992px) {
    .action-item {
      font-size: 1.25rem;

      .icon-wrapper .mini-cart-count {
        font-size: 0.625rem;
        padding: 0.25rem;
        min-width: 1.125rem;
      }
    }
  }
</style>
